export default __webpack_public_path__ + "static/media/anthem-website-logos_bornthisway.267abd17.webp";